import { Privilege } from '../../privilege';

import { V1User } from './user';
import { V1Workspace } from './workspace';

type Group = {
  auto_add: boolean;
  email_forwarding_disabled: boolean;
  members: V1User[];
  name: string;
  owner: V1User | V1Workspace;
  permission: Privilege;
  slug: string;
};

declare global {
  namespace BB {
    type V1Group = Group;
  }
}

export type V1Group = Group;
